import { render, staticRenderFns } from "./batchUpload.vue?vue&type=template&id=f553b3c0&scoped=true&"
import script from "./batchUpload.vue?vue&type=script&lang=js&"
export * from "./batchUpload.vue?vue&type=script&lang=js&"
import style0 from "./batchUpload.vue?vue&type=style&index=0&id=f553b3c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f553b3c0",
  null
  
)

export default component.exports